<template>
  <div>
    <v-row>
      <v-col cols="6">
        <h1 class="headline font-weight-light mb-3">
          <router-link class="link-a" :to="'/Inventory/Issue'">
            VIEW ISSUE</router-link
          >
          / PRINT
        </h1>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6" class="text-right">
        <v-btn rounded small @click="print()">
          <v-icon class="mr-1" dark small>mdi-printer</v-icon>
          Print</v-btn
        >
      </v-col>
    </v-row>
    <div id="printDiv">
      <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
      <div style="margin: 30px !important;">
        <v-row class="mt-4">
          <v-col cols="3">
            <img
              src="../../assets/bardode/acacia2.png"
              style="width: 60% !important;"
            />
          </v-col>
          <v-col cols="6" class="text-center">
            <b>เอกสารใบเบิก Part</b>
          </v-col>
          <v-col cols="3">
            <b>วันที่ : {{ data_print.issue_date }}</b>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="2" class="text-right"><b>ส่งจาก :</b></v-col>
          <v-col cols="4">{{ data_print.from_branch }}</v-col>
          <v-col cols="2" style="font-size:20px;" class="text-right"
            ><b>ส่งถึง :</b></v-col
          >
          <v-col cols="4" style="font-size:20px;">{{
            data_print.branch_name
          }}</v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
          <v-col cols="4">{{ data_print.from_addr }}</v-col>
          <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
          <v-col cols="4">{{ data_print.branch_addr_en }}</v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>Project :</b></v-col>
          <v-col cols="4">{{ data_print.project_name }}</v-col>
          <v-col cols="2" class="text-right"><b>Refer Case :</b></v-col>
          <v-col cols="4">{{ data_print.case_refer }}</v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>Case No :</b></v-col>
          <v-col cols="4">{{ data_print.case_id }}</v-col>
          <v-col cols="2" class="text-right"><b>Site Address :</b></v-col>
          <v-col cols="4">{{ data_print.site_name }}</v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <table border="1" width="100%">
              <thead>
                <tr
                  class="text-center"
                  style="background-color: rgb(221, 221, 221);"
                >
                  <th>No</th>
                  <th>Description</th>
                  <th>Single Part</th>
                  <th>Serial Number</th>
                  <th style="width: 50px;">Good</th>
                  <th style="width: 50px;">Bad</th>
                  <th style="width: 50px;">DOA</th>
                  <th>Same Item S/N</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(n, index) in data_print.parts_print" :key="index">
                  <td class="text-center">{{ index + 1 }}.</td>
                  <td class="text-center">
                    {{ n.part_description }}
                  </td>
                  <td class="text-center">
                    {{ n.singlepart }}
                  </td>
                  <td class="text-center">{{ n.serial }}</td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                 
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="2" class="text-left">
            <b class="red--text cur-p">ส่วนเบิก Part</b>
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้ส่ง (Inventory)</b>
            ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้รับ (Engineer)</b>
            ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="2" class="text-left">
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่ส่ง</b> ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่รับ</b> ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-4" style="margin-top: 4px;">
          <v-col cols="12" class="text-center">
        <div style="border-top: 1px dashed #000; margin-bottom: 20px;"></div>
        </v-col>
      </v-row>  
        <v-row class="mt-4">
          <v-col cols="2" class="text-left">
            <b class="red--text cur-p">ส่วนคืน Part</b>
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้ส่ง (Engineer)</b>
            ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้ผู้รับ (Inventory)</b>
            ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="2" class="text-left">
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่ส่ง</b> ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่รับ</b> ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="12"><hr /></v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="3">
            <img
              src="../../assets/bardode/acacia2.png"
              style="width: 60% !important;"
            />
          </v-col>
          <v-col cols="6" class="text-center">
            <b>เอกสารใบเบิก Part</b>
          </v-col>
          <v-col cols="3">
            <b>วันที่ : {{ data_print.issue_date }}</b>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="2" class="text-right"><b>ส่งจาก :</b></v-col>
          <v-col cols="4">{{ data_print.from_branch }}</v-col>
          <v-col cols="2" style="font-size:20px;" class="text-right"
            ><b>ส่งถึง :</b></v-col
          >
          <v-col cols="4" style="font-size:20px;">{{
            data_print.branch_name
          }}</v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
          <v-col cols="4">{{ data_print.from_addr }}</v-col>
          <v-col cols="2" class="text-right"><b>ที่อยู่ :</b></v-col>
          <v-col cols="4">{{ data_print.branch_addr_en }}</v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>Project :</b></v-col>
          <v-col cols="4">{{ data_print.project_name }}</v-col>
          <v-col cols="2" class="text-right"><b>Refer Case :</b></v-col>
          <v-col cols="4">{{ data_print.case_refer }}</v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="2" class="text-right"><b>Case No :</b></v-col>
          <v-col cols="4">{{ data_print.case_id }}</v-col>
          <v-col cols="2" class="text-right"><b>Site Address :</b></v-col>
          <v-col cols="4">{{ data_print.site_name }}</v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="12">
            <table border="1" width="100%">
              <thead>
                <tr
                  class="text-center"
                  style="background-color: rgb(221, 221, 221);"
                >
                <th>No</th>
                  <th>Description</th>
                  <th>Single Part</th>
                  <th>Serial Number</th>
                  <th style="width: 50px;">Good</th>
                  <th style="width: 50px;">Bad</th>
                  <th style="width: 50px;">DOA</th>
                  <th>Same Item S/N</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(n, index) in data_print.parts_print" :key="index">
                  <td class="text-center">{{ index + 1 }}.</td>
                  <td class="text-center">
                    {{ n.part_description }}
                  </td>
                  <td class="text-center">
                    {{ n.singlepart }}
                  </td>
                  <td class="text-center">{{ n.serial }}</td>
                  <td class="text-center">{{ n.status }}</td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col cols="2" class="text-left">
            <b class="red--text cur-p">ส่วนเบิก Part</b>
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้ส่ง (Inventory)</b>
            ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้รับ (Engineer)</b>
            ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="2" class="text-left">
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่ส่ง</b> ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่รับ</b> ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-4" style="margin-top: 4px;">
          <v-col cols="12" class="text-center">
        <div style="border-top: 1px dashed #000; margin-bottom: 20px;"></div>
        </v-col>
      </v-row>  
        <v-row class="mt-4">
          <v-col cols="2" class="text-left">
            <b class="red--text cur-p">ส่วนคืน Part</b>
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้ส่ง (Engineer)</b>
            ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>ผู้ผู้รับ (Inventory)</b>
            ___________________________________
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="2" class="text-left">
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่ส่ง</b> ___________________________________
          </v-col>
          <v-col cols="5" class="text-center">
            <b>วันที่รับ</b> ___________________________________
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import { mapState, mapMutations } from "vuex";
import VueHtmlToPaper from "vue-html-to-paper";

const url = `${process.env.VUE_APP_ROOT_API}/api/issue_print/`;
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

export default {
  mounted() {
    this.get_data();
  },
  ...mapMutations(["mutateMiniSidebar"]),
  methods: {
    async get_data() {
      await axios
        .get(
          url +
            this.$route.params.maincase_id +
            "/" +
            this.$route.params.subcase
        )
        .then((response) => {
          // console.log(response)
          console.log(response.data);
          this.data_print = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    print() {
      const localOptions = {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        ],
      };

      this.$htmlToPaper("printDiv", localOptions, () => {});
    },
  },
  data() {
    return {
      data_print: [],
    };
  },
};

</script>
